import { useMutation } from 'react-query';

import { axios } from 'configurations/axios';
import { IResponseAPI } from 'models/interfaces/IResponseAPI';
import { useSessionStore } from 'session/useSessionStore';
import { ISrid } from '../models/interfaces/ISrid';

type SearchSridVariables = {
    term: string;
};

export const useSearchSrid = () => {
    const { host, jwt } = useSessionStore(state => ({
        host: state.tenantConfiguration?.endpoints.webApiHost,
        jwt: state.jwtToken,
    }));

    return useMutation<ISrid[], unknown, SearchSridVariables>(
        async ({ term }) => {
            const response = await axios.get<IResponseAPI<ISrid[]>>(
                `${host}/SRID/SearchByTitle`,
                {
                    params: { term },
                    headers: {
                        Authorization: 'Bearer ' + jwt,
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data.Result;
        }
    );
};
